import React, { useState } from 'react';
import '../../styles/NotificationsContent.css';
import { FaArrowLeft } from 'react-icons/fa';

function NotificationsContent({ onBack }) {
  const [activityNotifications, setActivityNotifications] = useState(true);
  const [trendingNotifications, setTrendingNotifications] = useState(true);
  const [communityUpdatesNotifications, setCommunityUpdatesNotifications] = useState(true);
  const [pushNotificationsEnabled, setPushNotificationsEnabled] = useState(true);

  const handleToggle = (type) => {
    switch (type) {
      case 'activity':
        setActivityNotifications(!activityNotifications);
        break;
      case 'trending':
        setTrendingNotifications(!trendingNotifications);
        break;
      case 'community':
        setCommunityUpdatesNotifications(!communityUpdatesNotifications);
        break;
      case 'push':
        setPushNotificationsEnabled(!pushNotificationsEnabled);
        // If toggling master push, you might want to update individual settings as well
        break;
      default:
        break;
    }
    // In a real application, you would also save these settings to the backend
  };

  const handleViewInAppNotifications = () => {
    // Implement navigation or modal display for in-app notifications
    console.log('View In-App Notifications');
  };

  return (
    <div className="notifications-container">
      <div className="notifications-header">
        <button onClick={onBack} className="back-button"><FaArrowLeft /></button>
        <h2>NOTIFICATIONS</h2>
      </div>

      <div className="notification-section">
        <h3>Activity</h3>
        <p>Likes or reactions to your vents.</p>
        <label className="toggle-switch">
          <input type="checkbox" checked={activityNotifications} onChange={() => handleToggle('activity')} />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="notification-section">
        <h3>Trending Topics</h3>
        <p>Alerts when certain topics or vents become popular within the community.</p>
        <label className="toggle-switch">
          <input type="checkbox" checked={trendingNotifications} onChange={() => handleToggle('trending')} />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="notification-section">
        <h3>Community Updates</h3>
        <p>Announcements from the app administrators (e.g., new features, community guidelines updates).</p>
        <label className="toggle-switch">
          <input type="checkbox" checked={communityUpdatesNotifications} onChange={() => handleToggle('community')} />
          <span className="slider round"></span>
        </label>
      </div>

      <div className="notification-management-section">
        <h3>Notification Management</h3>
        <div className="management-item">
          <p><b>Enable/Disable Notifications:</b> A master toggle to turn all push notifications on or off.</p>
          <label className="toggle-switch">
            <input type="checkbox" checked={pushNotificationsEnabled} onChange={() => handleToggle('push')} />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="management-item">
          <p><b>Granular Control by Type:</b> Individual toggles to enable or disable specific types of notifications (e.g., replies, trending, announcements).</p>
          {/* The toggles above for Activity, Trending, Community serve this purpose */}
        </div>
        <div className="management-item">
          <p><b>In-App Notifications:</b> A section to view a history of notifications received within the app itself, even if push notifications are disabled.</p>
          <button className="view-in-app-button" onClick={handleViewInAppNotifications}>View In-App Notifications</button>
        </div>
      </div>
    </div>
  );
}

export default NotificationsContent;
